export const FETCH_CHANNELS = 'FETCH_CHANNELS',
  FETCH_CHANNELS_SUCCESS = 'FETCH_CHANNELS_SUCCESS',
  FETCH_CHANNELS_FAILURE = 'FETCH_CHANNELS_FAILURE',
  FETCH_CHANNEL_ACTIVITY = 'FETCH_CHANNEL_ACTIVITY',
  FETCH_CHANNELS_ACTIVITY_SUCCESS = 'FETCH_CHANNELS_ACTIVITY_SUCCESS',
  FETCH_CHANNELS_ACTIVITY_FAILURE = 'FETCH_CHANNELS_ACTIVITY_FAILURE',
  FETCH_INTEGRATIONS = 'FETCH_INTEGRATIONS',
  FETCH_INTEGRATIONS_SUCCESS = 'FETCH_INTEGRATIONS_SUCCESS',
  FETCH_INTEGRATIONS_FAIL = 'FETCH_INTEGRATIONS_FAIL';

export const UPDATE_CHANNEL_EMAIL = 'UPDATE_CHANNEL_EMAIL';
export const UPDATE_CHANNEL_EMAIL_SUCCESS = 'UPDATE_CHANNEL_EMAIL_SUCCESS';
export const UPDATE_CHANNEL_EMAIL_FAILURE = 'UPDATE_CHANNEL_EMAIL_FAILURE';

export const UPDATE_CHANNEL_DEVICE = 'UPDATE_CHANNEL_DEVICE';
export const UPDATE_CHANNEL_DEVICE_SUCCESS = 'UPDATE_CHANNEL_DEVICE_SUCCESS';
export const UPDATE_CHANNEL_DEVICE_FAILURE = 'UPDATE_CHANNEL_DEVICE_FAILURE';

export const UNTRUST_DEVICE = 'UNTRUST_DEVICE';
export const UNTRUST_DEVICE_SUCCESS = 'UNTRUST_DEVICE_SUCCESS';
export const UNTRUST_DEVICE_FAILURE = 'UNTRUST_DEVICE_FAILURE';



// WEBPACK FOOTER //
// ./src/views/channels/_types.js